import React from 'react';
import PropTypes from 'prop-types';
import { Provider, connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getAuthenticated, authActions } from '../core/auth';
import { Routes } from './routes';

function Root({ history, store, authenticated }) {
  return (
    <Provider store={store}>
      <Routes history={history} authenticated={authenticated} />
    </Provider>
  );
}

Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
  authenticated: getAuthenticated,
});

export default connect(mapStateToProps, authActions)(Root);



// WEBPACK FOOTER //
// ./src/views/root.js